import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SnackBarComponent } from './snack-bar.component';
import { SnackBarService } from './snack-bar.service';

@NgModule({
  declarations: [],
  imports: [CommonModule, SnackBarComponent],
  providers: [SnackBarService],
})
export class SnackBarModule {}
